import React from 'react';
import { ButtonV2, Link } from '@zola/zola-ui';
import { isMobile } from '@zola-helpers/client';

import { ConfigureAddressCollectionWelcomeModalDispatchProps } from 'components/manage/guestlist/addressCollection/ConfigureAddressCollectionWelcomeModal';

import modalFirst from 'assets/images/guestlist/modalFirst.png';
import modalSecond from 'assets/images/guestlist/modalSecond.png';
import modalThird from 'assets/images/guestlist/modalThird.png';
import mobileModalFirst from 'assets/images/guestlist/m-modalFirst.jpg';
import mobileModalSecond from 'assets/images/guestlist/m-modalSecond.jpg';
import mobileModalThird from 'assets/images/guestlist/m-modalThird.jpg';

import styles from './ConfigureAddressCollectionWelcomeModal.module.less';

type Tiles = {
  img: string;
  dek: string;
};

const tiles: Tiles[] = [
  {
    img: isMobile() ? mobileModalFirst : modalFirst,
    dek: 'Text, DM, or email your link to guests.',
  },
  {
    img: isMobile() ? mobileModalSecond : modalSecond,
    dek: 'Guests click and fill out a form.',
  },
  {
    img: isMobile() ? mobileModalThird : modalThird,
    dek: 'Their info appears in your guest list (ta-da!).',
  },
];

const ConfigureAddressCollectionWelcomeModal: React.FC<ConfigureAddressCollectionWelcomeModalDispatchProps> = ({
  onCloseModal,
}) => {
  return (
    <div className={styles.container}>
      <Link
        href="/wedding/manage/website/manage"
        arrow
        arrowPosition="prefix"
        className={styles.back}
      >
        Back To Website
      </Link>
      <h2 className={styles.title}>Get 100s of Addresses with 1 Magic Link</h2>
      <div className={styles.tiles}>
        {tiles.map(
          (tile, i): JSX.Element => (
            <div className={styles.tile} key={i}>
              <img src={tile.img} alt={tile.dek} className={styles.img} />
              <span className={styles.dek}>{tile.dek}</span>
            </div>
          )
        )}
      </div>
      <ButtonV2 onClick={onCloseModal}>Set Up Your Magic Link</ButtonV2>
    </div>
  );
};

export default ConfigureAddressCollectionWelcomeModal;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ConfigureAddressCollectionWelcomeModal/ConfigureAddressCollectionWelcomeModal.tsx